"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
var _react2 = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Wrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e11d84160"
} : {
  target: "e11d84160",
  label: "Wrapper"
})(({
  spaceBetween
}) => /*#__PURE__*/(0, _react.css)("display:flex;gap:1em;width:100%;justify-content:", spaceBetween ? 'space-between' : 'flex-end', ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;")));
const ActionButtons = ({
  children,
  className,
  spaceBetween = true
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(Wrapper, {
  className: className,
  spaceBetween: spaceBetween,
  children: children
});
var _default = exports.default = ActionButtons;